import React from 'react';
import { Link } from 'react-router-dom';
import { Plus, Key, Clock, Users, BarChart3, Settings } from 'lucide-react';

const QuickActionsBlock = ({ size = 'medium' }) => {
  const actions = [
    {
      id: 'new-project',
      name: 'New Project',
      icon: Plus,
      href: '/dashboard',
      color: 'celadon'
    },
    {
      id: 'api-keys',
      name: 'API Keys',
      icon: Key,
      href: '/api-keys',
      color: 'gray'
    },
    {
      id: 'logs',
      name: 'View Logs',
      icon: Clock,
      href: '/logs',
      color: 'gray'
    },
    {
      id: 'shared',
      name: 'Shared Prompts',
      icon: Users,
      href: '/shared-prompts',
      color: 'gray'
    },
    {
      id: 'analytics',
      name: 'Analytics',
      icon: BarChart3,
      href: '/analytics',
      color: 'celadon'
    },
    {
      id: 'settings',
      name: 'Settings',
      icon: Settings,
      href: '/settings',
      color: 'gray'
    }
  ];

  const getDisplayActions = () => {
    switch (size) {
      case 'small':
        return actions.slice(0, 4);
      case 'medium':
        return actions.slice(0, 4);
      default:
        return actions.slice(0, 4);
    }
  };

  const displayActions = getDisplayActions();

  const getActionClasses = (color) => {
    if (color === 'celadon') {
      return 'rounded-2xl transition-all duration-200 flex flex-col items-center justify-center text-center group border bg-celadon-50 hover:bg-celadon-100 dark:bg-celadon-900/30 dark:hover:bg-celadon-900/50 text-celadon-700 hover:text-celadon-800 dark:text-celadon-300 dark:hover:text-celadon-200 border-celadon-200 hover:border-celadon-300 dark:border-celadon-700/50 dark:hover:border-celadon-600/50 hover:shadow-lg dark:hover:shadow-[0_8px_30px_-6px_rgba(0,0,0,0.3)]';
    } else if (color === 'orange') {
      return 'rounded-2xl transition-all duration-200 flex flex-col items-center justify-center text-center group border bg-orange-50 hover:bg-orange-100 dark:bg-orange-900/30 dark:hover:bg-orange-900/50 text-orange-700 hover:text-orange-800 dark:text-orange-300 dark:hover:text-orange-200 border-orange-200 hover:border-orange-300 dark:border-orange-700/50 dark:hover:border-orange-600/50 hover:shadow-lg dark:hover:shadow-[0_8px_30px_-6px_rgba(0,0,0,0.3)]';
    }
    else{
      return 'rounded-2xl transition-all duration-200 flex flex-col items-center justify-center text-center group border bg-gray-50 hover:bg-gray-100 dark:bg-gray-700/50 dark:hover:bg-gray-600/50 text-gray-700 hover:text-gray-800 dark:text-gray-300 dark:hover:text-gray-200 border-gray-200 hover:border-gray-300 dark:border-gray-600/50 dark:hover:border-gray-500/50 hover:shadow-lg dark:hover:shadow-[0_8px_30px_-6px_rgba(0,0,0,0.3)]';
    }
  };

  const getGridLayout = () => {
    switch (size) {
      case 'small':
        return {
          containerClass: 'grid grid-cols-2 gap-2 h-full',
          itemClass: 'p-3 h-3/4'
        };
      case 'medium':
        return {
          containerClass: 'grid grid-cols-2 gap-3 h-full',
          itemClass: 'p-4 h-3/4'
        };
      default:
        return {
          containerClass: 'grid grid-cols-2 gap-3 h-full',
          itemClass: 'p-4 h-3/4'
        };
    }
  };

  const layout = getGridLayout();

  return (
    <div className="h-full overflow-hidden">
      <div className={layout.containerClass}>
        {displayActions.map((action) => {
          const IconComponent = action.icon;
          
          return (
            <Link
              key={action.id}
              to={action.href}
              className={`${getActionClasses(action.color)} ${layout.itemClass}`}
            >
              <IconComponent className={`mb-2 flex-shrink-0 group-hover:scale-110 transition-transform duration-200 ${
                size === 'small' ? 'h-5 w-5' : 'h-6 w-6'
              }`} />
              <span className={`font-semibold leading-tight text-center ${
                size === 'small' ? 'text-xs' : 'text-xs'
              }`}>
                {action.name}
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default QuickActionsBlock; 